import $ from "jquery";
import "particles.js";

const ctaMoon = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.js-MoonEffect'
        }
        if ($(el.main).length === 0) return

        $(el.main).each(function () {
            const id = $(this).attr('id')
            // @ts-ignore
            window.particlesJS.load(
                id,
                "/wp-content/themes/neve-child/starter-hello-elementor-child/assets/src/json/cta-moon.particle.json",
                function () {
                    // console.log('callback - particles-js config loaded');
                },
            );
        })

    }
    init()
}

try {
    ctaMoon()
} catch (error) {
    console.error('ctaMoon', error)
}